import { cn } from '@/shared/helpers/classnames'

import type { FC } from 'react'
import { ChevronDown } from 'react-bootstrap-icons'

import { Trigger as RadixDropdownTrigger } from '@radix-ui/react-dropdown-menu'

import { ClearButton } from './ClearButton'
import type { SelectTriggerProps } from './types'

/**
 * SelectTrigger component - Bouton déclencheur du select
 *
 * @example
 * ```tsx
 * <Select.Trigger isOpen={isOpen} mode="single">
 *   {displayValue}
 * </Select.Trigger>
 * ```
 */
export const SelectTrigger: FC<SelectTriggerProps> = ({
  children,
  isOpen = false,
  disabled = false,
  readonly = false,
  ariaLabel,
}) => {
  return (
    <div
      className={cn('selectw-trigger', {
        'selectw-trigger-open': isOpen,
        'selectw-trigger-readonly': readonly,
      })}
    >
      <RadixDropdownTrigger disabled={disabled || readonly} asChild>
        <button className="selectw-trigger-button" role="combobox" aria-label={ariaLabel}>
          <span className="selectw-trigger-value">{children}</span>

          {!readonly && (
            <ChevronDown
              className={cn('selectw-trigger-icon', {
                'selectw-trigger-icon-open': isOpen,
              })}
            />
          )}
        </button>
      </RadixDropdownTrigger>
      <ClearButton />
    </div>
  )
}

SelectTrigger.displayName = 'SelectTrigger'
